App.namespace.wrap('components.room_pricing_table', ($pricingTable, sectionType, options = {}) => {
  const $days = $pricingTable.findMany('.c-pricing-table__day');

  const $opened = $pricingTable.findAny('.c-pricing-table__day.c-pricing-table__day--expanded');
  let $active = $opened.length === 1 ? $opened : null;

  const closeAllOpenedTabs = ($el) => {
    $el.findAny('.c-pricing-table__details').hide();
    $el.findAny('.c-pricing-table__button').removeClass('c-pricing-table__button--active');
  };

  const hideRow = ($el, { immediate } = {}) => {
    const $body = $el.findOne('.c-pricing-table__body');

    if (immediate) {
      $el.removeClass('c-pricing-table__day--expanded');
      $body.hide();
      closeAllOpenedTabs($el);
      return;
    }

    $el.addClass('c-pricing-table__day--removing');
    $el.removeClass('c-pricing-table__day--removing c-pricing-table__day--expanded');
    $body.slideUp(300, () => {
      closeAllOpenedTabs($el);
    });
  };

  const showRow = ($el, { initial } = {}) => {
    // if day is closed don't open it.
    if ($el.hasClass('c-pricing-table__day--closed')) {
      return;
    }

    if ($active) {
      hideRow($active, { immediate: true });
      $active = null;
    }

    const $body = $el.findOne('.c-pricing-table__body');

    $el.addClass('c-pricing-table__day--expanding c-pricing-table__day--expanded');

    if ($el[0].scrollIntoViewIfNeeded && !initial) {
      const isMobile = window.matchMedia('(max-width: 768px)').matches;
      $el[0].scrollIntoViewIfNeeded(isMobile);
    }

    $body.slideDown(300, () => {
      $el.removeClass('c-pricing-table__day--expanding');
    });

    $active = $el;
  };

  const showDate = (date, options = {}) => {
    showRow(
      $pricingTable.findOne(`.c-pricing-table__day[data-day-of-week="${date}"]`),
      options,
    );
  };

  $days.on('click', '.c-pricing-table__row--header', (event) => {
    const $el = $(event.delegateTarget);

    if ($active && $active.is($el)) {
      hideRow($el);
      $active = null;
      return;
    }

    options?.onRowClick?.($el);

    showRow($el);

    if (window.App.views.shared?.fixTooltips) {
      window.App.views.shared.fixTooltips({repaint: 1, container: $el.get(0), force: 1});
    }
  });

  $pricingTable.findAny('.c-pricing-table__button[data-target]').on('click', (e) => {
    const $el = $(e.currentTarget);
    const $body = $el.parents('.c-pricing-table__body');
    const id = $el.data('target');
    const $toShow = $body.findOne(`.c-pricing-table__details[data-id="${id}"]`);
    const $button = $(e.currentTarget);

    $body.findMany('.c-pricing-table__button').not($button).removeClass('c-pricing-table__button--active');
    $body.findMany('.c-pricing-table__details').not($toShow).hide();

    const copy = $('#pricingSection-comment-' + id).html(); // #pricingSection-comment-pricing, #pricingSection-comment-catering

    if ($toShow.is(':visible')) {
      $toShow.hide();
    } else {
      $toShow.fadeIn();
      $toShow.html(copy);
    }
    $button.toggleClass('c-pricing-table__button--active');
  });

  $pricingTable.findAny('.js-scroll-to-packages').on('click', () => {
    const isMobile = window.matchMedia('(max-width: 600px)').matches;
    const PADDING = isMobile ? 0 : 150;

    $('html, body').animate({
      scrollTop: $.fn.findOneInDocument('#eventOffersSection').offset().top - PADDING,
    }, 300);

    window.setTimeout(() => {
      // show first package
      $('.c-pricing-table[data-type=packages] .c-pricing-table__day:first-of-type')
        .not('.c-pricing-table__day--expanded')
        .find('.c-pricing-table__row--header')
        .click();
    }, 500);
  });

  /**
   * Data tracking
   */
  $pricingTable.on('click', '.c-pricing-table__row--header', e => {
    const $row = $(e.currentTarget);
    const name = $row.findOne('.c-pricing-table__item--package, .c-pricing-table__item--day')
      .text()
      .trim();
    const type = e.delegateTarget.dataset.type;

    App.track.all({
      category: 's-room-pricing',
      action: 'row-clicked',
      label: type,
      value: name,
    });
  });

  if (sectionType === 'pricing' && window.__TGV_ROOM_DEFAULT_DATE) {
    showDate(window.__TGV_ROOM_DEFAULT_DATE, { initial: true });
  }

  return {
    showDate,
  };
});
